export default {
  colors: {
    base: '#2f2f2f',
    secondary: '#424240',
    tertiary: '#696966',
    highlight: '#FF4240',
    background: '#EFEFEE',
    border: '#DDDDDD',
    button: '#696966',
    text: '#2f2f2f',
    code: '#DDDDDD',
    navbar: '#2f2f2f',
    navbarText: '#EFEFEE',
    modes: 
    {
      dark: 
      {
        base: '#2f2f2f',
        secondary: '#696966',
        tertiary: '#424240',
        highlight: '#DD4242',
        background: '#1C1C1C',
        border: '#2f2f2f',
        button: '#424240',
        text: '#DDDDDD',
        code: '#2f2f2f',
        navbar: '#2f2f2f',
        navbarText: '#EFEFEE',
      },
    },
  },
  fonts: {
    body:
      "'SF Pro Display', '-apple-system', 'BlinkMacSystemFont', 'San Francisco', 'Helvetica Neue', 'Helvetica', 'Ubuntu', 'Roboto', 'Noto', 'Segoe UI', 'Arial', sans-serif",
    heading:
      "'SF Pro Display', '-apple-system', 'BlinkMacSystemFont', 'San Francisco', 'Helvetica Neue', 'Helvetica', 'Ubuntu', 'Roboto', 'Noto', 'Segoe UI', 'Arial', sans-serif",
    monospace: `"Operator Mono", Consolas, Menlo, Monaco, source-code-pro, Courier New, monospace`,
    normalWeight: '400',
    boldWeight: '600',
  },
  sizes: {
    maxWidth: '1050px',
    maxWidthCentered: '800px',
  },
  responsive: {
    small: '35em',
    medium: '50em',
    large: '70em',
  },
}
